import React, { useState } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

const AddColumnModal = ({ preview, previewHandler, successHandler }) => {
  // STATES
  const [isLoading, setLoading] = useState(false);

  // CONST VALS
  const { http } = global.services;
  const [form] = Form.useForm();

  // HANDLERS
  const submitHandler = (values) => {
    setLoading(true);
    http
      .post(`pipeline`, values)
      .finally(() => setLoading(false))
      .then(({ data }) => {
        toast.success("Column created successfully");
        successHandler(data);
        previewHandler();
        form.resetFields();
      })
      .catch(() => {});
  };

  return (
    <Modal
      visible={preview}
      centered
      className="add-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Add Status Column</h2>
      <p>Enter name of column below</p>
      <Form form={form} onFinish={submitHandler}>
        <label htmlFor="name">Name</label>
        <Form.Item
          name="name"
          rules={[
            { required: true, message: "Column name is required" },
            { max: 300, message: "Column name cannot be more than 300 characters" },
          ]}
        >
          <Input type="text" placeholder="Enter column name" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="submit" type="submit">
            {isLoading ? <BeatLoader size={8} color="#fff" /> : "Submit"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddColumnModal;
